import React, { useEffect, useReducer, useState } from 'react'

import { Dialog, DialogTrigger } from '@/Components/ui/dialog'
import { Button } from '@/Components/ui/button'

import Datatable from '@/Components/Common/Datatable'
import { Input } from '@/Components/ui/input'
import { useLocation } from 'react-router-dom'

import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import { SquarePlus } from 'lucide-react'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'
import { useAuth } from '@/Context/AuthContext'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { checkPermission } from '@/utils/helper'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'
import FollowupStatusService from '@/Service/FollowupStatusService'
import CreateFollowupStatus from '../CreateFollowupStatus'
import FollowupStatusColumn from './FollowupStatusColumn'

const FollowupStatus = () => {
    const { userInfo } = useAuth()

    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totalAssessmentCount: 0,
        isDataFetching: false,
        deleteConfirmationOpen: false,
        followupStatus: [],
        followupStatusSearch: '',
        isOpen: false,
        deleteId: [],
        allcheck: false,
        queryParam: {
            page: 1,
            followup_status: '',
        },
    })
    const [debouncefollowupStatusSearch] = useDebounce(event.followupStatusSearch, Constant.DEBOUNCE_DELAY)

    const location = useLocation()

    const getFollowupStatus = async (page = 1) => {
        console.log('in ge assessment')
        updateEvent({ isDataFetching: true, followupStatus: [] })
        
        try {
            const resp = await FollowupStatusService.getFollowupStatus(event.queryParam)
            if (resp.data.success) {
               
                updateEvent({ followupStatus: resp.data.data, totalFollowupCount: resp.data.pagination.total_record })
            }
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getFollowupStatus()
    }, [event.queryParam.page, event.queryParam.followup_status])
    useEffect(() => {
        console.log('debouncedmitem', debouncefollowupStatusSearch)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                followup_status: debouncefollowupStatusSearch,
            },
        })
    }, [debouncefollowupStatusSearch])

    const deletefollowupStatus = async (action) => {
        if (!action) {
            updateEvent({ deleteConfirmationOpen: false })
            return false
        }
        try {
            const resp = await FollowupStatusService.deleteFollowupStatus(event.deleteId)
            if (resp.data.success) {
                getFollowupStatus()
            }
            updateEvent({ deleteId: [], allcheck: false })
        } catch (err) {
            console.log('err', err)
        }
        updateEvent({ deleteConfirmationOpen: false })
    }
    return (
        <>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {checkPermission(RequiredPermission.PROCESS.CREATE, userInfo.roles) && (
                        <Dialog open={event.isOpen} onOpenChange={() => updateEvent({ isOpen: !event.isOpen })}>
                            <DialogTrigger>
                                <Button className="bg-primary-btn hover:bg-primary-purpal">
                                    <SquarePlus />
                                    Add Followup Status
                                </Button>
                            </DialogTrigger>
                            <DialogTrigger></DialogTrigger>
                            <CreateFollowupStatus getfollowupStatus={getFollowupStatus} setIsOpen={(isOepn) => updateEvent({ isOpen: isOepn })} />
                        </Dialog>
                    )}

                    {checkPermission(RequiredPermission.PROCESS.DELETE, userInfo.roles) && event.deleteId.length > 0 && (
                        <Button
                            variant="outline"
                            onClick={() => updateEvent({ deleteConfirmationOpen: true })}
                            className={`ml-[10px] ${event.deleteId.length > 0 ? 'block' : 'hidden'}`}
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </HeaderCard>
            <ConfirmationPopup
                open={event.deleteConfirmationOpen}
                message="Are you sure you want to delete this permanently?"
                type={DeleteConfirmationTypeEnum.DELETE}
                setOpen={() => updateEvent({ deleteConfirmationOpen: !event.deleteConfirmationOpen })}
                handleAction={deletefollowupStatus}
            />
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input
                        type="text"
                        value={event.followupStatusSearch}
                        onChange={(e) => updateEvent({ followupStatusSearch: e.target.value })}
                        placeholder="Followup Status"
                    />
                </div>
                <Datatable
                    columns={FollowupStatusColumn()}
                    data={event.followupStatus}
                    totalDataCount={event.totalFollowupCount}
                    allcheck={event.allcheck}
                    setAllcheck={event.setAllcheck}
                    deleteId={event.deleteId}
                    updateEvent={updateEvent}
                    loading={event.isDataFetching}
                />
            </BodyCard>
        </>
    )
}

export default FollowupStatus
